import React from 'react';
import {Label, Link} from '@gravity-ui/uikit';
import {PropertyRow, formatCurrency} from '../../../../shared';
import {formatDate} from 'date-fns';
import {OrderDetailModel} from '../../model';
import {getStatusBenefactorOrder} from '../../lib';
import {useFundraiser} from '../../../fundraiser';
import styles from './DetailOrderInformation.module.scss';

interface DetailOrderInformationProps {
  orderData: OrderDetailModel;
}

export const DetailOrderInformation = ({orderData}: DetailOrderInformationProps) => {
  // Получаем данные о fundraiser только если это AppealDonation и есть appealId
  const appealId = orderData.donationIntent.type === 'AppealDonation' ? orderData.donationIntent.appealId : undefined;

  const {getFundraiserById} = useFundraiser({
    id: appealId || '',
  });

  const fundraiserData = getFundraiserById.data;

  const getPaymentMethodDisplay = (paymentInfo: typeof orderData.paymentInformation) => {
    if (!paymentInfo) {
      return 'Не указано';
    }

    switch (paymentInfo.type) {
      case 'BankTransfer':
        return 'Банковский перевод';
      case 'CloudPaymentsCard':
        return 'Банковская карта (CloudPayments)';
      default:
        return paymentInfo.type || 'Неизвестно';
    }
  };

  const getDonationIntentDisplay = (donationIntent: typeof orderData.donationIntent) => {
    switch (donationIntent.type) {
      case 'AppealDonation':
        if (donationIntent.appealId) {
          const appealUrl = `/fundraisings/appeals/${donationIntent.appealId}`;
          const appealName = fundraiserData?.name || `Обращение #${donationIntent.appealId}`;

          return (
            <Link href={appealUrl} target="_blank" rel="noopener noreferrer" className={styles.appealLink}>
              Разовый, {appealName}
            </Link>
          );
        }
        return 'Пожертвование по обращению';
      case 'ProjectDonation':
        return 'Пожертвование по проекту';
      default:
        return donationIntent.type || 'Неизвестно';
    }
  };

  const status = getStatusBenefactorOrder(orderData.status);

  return (
    <div className={styles.detailsContainer}>
      <PropertyRow property="Сумма платежа" value={formatCurrency(orderData.intendedAmountSummary.total, {padFraction: true})} />
      <PropertyRow property="Статус заказа" value={<Label theme={status.theme}>{status.text}</Label>} />
      <PropertyRow property="Дата платежа" value={formatDate(orderData.createdAt, 'dd.MM.yyyy HH:mm:ss')} />
      <PropertyRow property="Payment ID" value={orderData.id} />
      <PropertyRow property="Намерение платежа" value={getDonationIntentDisplay(orderData.donationIntent)} />
      <PropertyRow property="Способ оплаты" value={getPaymentMethodDisplay(orderData.paymentInformation)} />
      <PropertyRow property="Сообщение об ошибке" value={orderData.failureMessage || '-'} />
    </div>
  );
};
